import { defineNuxtPlugin } from '#app/nuxt'
import { LazySvgoAds, LazySvgoBagCross, LazySvgoBagTick, LazySvgoBiography, LazySvgoBullet, LazySvgoCalendar, LazySvgoCampaignBudget, LazySvgoCampaignCpvs, LazySvgoCampaignKpis, LazySvgoCampaignList, LazySvgoCheckmark, LazySvgoCuteProfile, LazySvgoDanger, LazySvgoDiscovery, LazySvgoEr, LazySvgoFullAi, LazySvgoGlob, LazySvgoGoftino, LazySvgoGreenOak, LazySvgoHome, LazySvgoInfoCircle, LazySvgoInstagram, LazySvgoLargeAi, LazySvgoLoadingReportDoc, LazySvgoLocation, LazySvgoMinimalAi, LazySvgoMobile, LazySvgoNotification, LazySvgoOak, LazySvgoPageGroupAdvancedSearch, LazySvgoProfileCircle, LazySvgoProfile, LazySvgoRankBadge01, LazySvgoRankBadge02, LazySvgoRankBadge03, LazySvgoRankBadge04, LazySvgoRankBadge05, LazySvgoRankBadge06, LazySvgoReportSummary, LazySvgoSanjabLogo, LazySvgoSanjabTypography, LazySvgoSearchAdv, LazySvgoSignLogo, LazySvgoSimpleSearchEmptyState, LazySvgoSmallAi, LazySvgoSnOkStatusModalLeft, LazySvgoSnOkStatusModalRight, LazySvgoSn, LazySvgoTelegram, LazySvgoTrends, LazySvgoUserBehindUser, LazySvgoWarning } from '#components'
const lazyGlobalComponents = [
  ["SvgoAds", LazySvgoAds],
["SvgoBagCross", LazySvgoBagCross],
["SvgoBagTick", LazySvgoBagTick],
["SvgoBiography", LazySvgoBiography],
["SvgoBullet", LazySvgoBullet],
["SvgoCalendar", LazySvgoCalendar],
["SvgoCampaignBudget", LazySvgoCampaignBudget],
["SvgoCampaignCpvs", LazySvgoCampaignCpvs],
["SvgoCampaignKpis", LazySvgoCampaignKpis],
["SvgoCampaignList", LazySvgoCampaignList],
["SvgoCheckmark", LazySvgoCheckmark],
["SvgoCuteProfile", LazySvgoCuteProfile],
["SvgoDanger", LazySvgoDanger],
["SvgoDiscovery", LazySvgoDiscovery],
["SvgoEr", LazySvgoEr],
["SvgoFullAi", LazySvgoFullAi],
["SvgoGlob", LazySvgoGlob],
["SvgoGoftino", LazySvgoGoftino],
["SvgoGreenOak", LazySvgoGreenOak],
["SvgoHome", LazySvgoHome],
["SvgoInfoCircle", LazySvgoInfoCircle],
["SvgoInstagram", LazySvgoInstagram],
["SvgoLargeAi", LazySvgoLargeAi],
["SvgoLoadingReportDoc", LazySvgoLoadingReportDoc],
["SvgoLocation", LazySvgoLocation],
["SvgoMinimalAi", LazySvgoMinimalAi],
["SvgoMobile", LazySvgoMobile],
["SvgoNotification", LazySvgoNotification],
["SvgoOak", LazySvgoOak],
["SvgoPageGroupAdvancedSearch", LazySvgoPageGroupAdvancedSearch],
["SvgoProfileCircle", LazySvgoProfileCircle],
["SvgoProfile", LazySvgoProfile],
["SvgoRankBadge01", LazySvgoRankBadge01],
["SvgoRankBadge02", LazySvgoRankBadge02],
["SvgoRankBadge03", LazySvgoRankBadge03],
["SvgoRankBadge04", LazySvgoRankBadge04],
["SvgoRankBadge05", LazySvgoRankBadge05],
["SvgoRankBadge06", LazySvgoRankBadge06],
["SvgoReportSummary", LazySvgoReportSummary],
["SvgoSanjabLogo", LazySvgoSanjabLogo],
["SvgoSanjabTypography", LazySvgoSanjabTypography],
["SvgoSearchAdv", LazySvgoSearchAdv],
["SvgoSignLogo", LazySvgoSignLogo],
["SvgoSimpleSearchEmptyState", LazySvgoSimpleSearchEmptyState],
["SvgoSmallAi", LazySvgoSmallAi],
["SvgoSnOkStatusModalLeft", LazySvgoSnOkStatusModalLeft],
["SvgoSnOkStatusModalRight", LazySvgoSnOkStatusModalRight],
["SvgoSn", LazySvgoSn],
["SvgoTelegram", LazySvgoTelegram],
["SvgoTrends", LazySvgoTrends],
["SvgoUserBehindUser", LazySvgoUserBehindUser],
["SvgoWarning", LazySvgoWarning],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
